import { useEffect } from 'react';
import { useAppForm } from 'hooks';
import { feedbackFormSchema } from '../constants';

interface UseFeedbackFormProps {
  existingFeedback?: {
    rating: number;
    comment?: string | null;
    selectedQuestions?: Array<{ id: string }>;
  } | null;
  isOpen: boolean;
}

export const useFeedbackForm = ({
  existingFeedback,
  isOpen,
}: UseFeedbackFormProps) => {
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
    watch,
    reset,
  } = useAppForm(feedbackFormSchema, {
    defaultValues: {
      rating: 0,
      comment: '',
      selectedQuestionIds: [],
    },
    mode: 'all',
  });

  // Reset form when drawer opens/closes or feedback status changes
  useEffect(() => {
    if (isOpen && existingFeedback) {
      reset({
        rating: existingFeedback.rating,
        comment: existingFeedback.comment || '',
        selectedQuestionIds:
          existingFeedback.selectedQuestions?.map(q => q.id) || [],
      });
    } else if (isOpen) {
      reset({
        rating: 0,
        comment: '',
        selectedQuestionIds: [],
      });
    }
  }, [isOpen, existingFeedback, reset]);

  const selectedQuestionIds = watch('selectedQuestionIds');
  const rating = watch('rating');

  return {
    control,
    handleSubmit,
    errors,
    isSubmitting,
    setValue,
    selectedQuestionIds,
    rating,
  };
};

